module.exports = __webpack_public_path__ + "static/media/COFFEE_SHOP_MEETING.553cbc2b.png";